module.exports = __webpack_public_path__ + "img/shopGuider@3x.d4b332f9.png";